import { createContext, useContext } from "react";
import { BotbReferAFriendContext } from "./types";

export const BotbRAFContext = createContext<BotbReferAFriendContext>({
  state: null,
  setState: null,
  minimumReferralsForGrantPrize: 5,
  closeRAFModal: null,
  showMoreDetails: {
    show: false,
    tab: 1,
  },
  setShowMoreDetails: null,
  showStatistics: false,
  setShowStatistics: null,
  showStatisticsCLick: null,
  statistics: [],
  congratsModalInvite: null,
  rafStatus: {
    maximumInvites: 25,
    startDate: 0,
    endDate: 0,
    programid: null,
    rafflePlayersQualified: 7,
    ftu: false,
    segment: null,
    cashPerInvite: 20,
    status: null,
    referredFriends: 3,
    referralUrl: "",
  },
  loading: true,
  calculatePercentage: null,
  preSubscriptionDataLoading: true,
  preSubscriptionData: {
    features: [],
    header: {
      subtitlep1: "",
      subtitlep2: "",
      subtitlep3: "",
      title: "",
      video: "",
      videoMobile: "",
      legalText: "",
    },
    offer: {
      bonus: "",
      description: "",
      expireTime: 0,
      headline: "",
      offerImage: "",
    },
  },
  setFTU: null,
  userName: "",
  viewDetailsClick: null,
  showInviteFriendsPopup: null,
  inviteFriendsPopup: false,
  IsRAFEnabled: false,
});

export const useBotbRAFContext = () => useContext(BotbRAFContext);
